import React, { useState } from 'react';

const MoodboardItem = ({ item, onEdit, onDelete }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  const renderContent = () => {
    switch (item.type) {
      case 'image':
        return (
          <div className="relative w-full h-full">
            <img 
              src={item.imageUrl} 
              alt={item.title || 'Image'} 
              className="w-full h-full object-cover"
            />
            {item.title && (
              <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-2 text-sm truncate">
                {item.title}
              </div>
            )}
          </div>
        );
      case 'link':
        return (
          <div className="flex flex-col h-full">
            <div className="bg-gray-100 p-3 flex-grow flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
              </svg>
            </div>
            <div className="p-2">
              <h4 className="font-medium text-sm">{item.title || 'Link'}</h4>
              <a 
                href={item.linkUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-xs text-primary-600 truncate block"
              >
                {item.linkUrl}
              </a>
            </div>
          </div>
        );
      case 'text':
        return (
          <div className="p-3 h-full flex flex-col">
            <h4 className="font-medium mb-1">{item.title || 'Note'}</h4>
            <p className="text-sm text-gray-600 flex-grow overflow-hidden">
              {item.textContent}
            </p>
          </div>
        );
      default:
        return (
          <div className="flex items-center justify-center h-full text-gray-400">
            <span>Unknown item type</span>
          </div>
        );
    }
  };
  
  return (
    <div 
      className="bg-white rounded-md shadow-sm overflow-hidden h-48 relative"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {renderContent()}
      
      {isHovered && (
        <div className="absolute top-2 right-2 flex space-x-1">
          <button 
            onClick={() => onEdit(item)}
            className="p-1 rounded-full bg-white shadow-md hover:bg-gray-100 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-600" viewBox="0 0 20 20" fill="currentColor">
              <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
            </svg>
          </button>
          <button 
            onClick={() => onDelete(item)}
            className="p-1 rounded-full bg-white shadow-md hover:bg-red-100 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-red-600" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      )}
      
      {item.tags && item.tags.length > 0 && (
        <div className="absolute bottom-2 left-2 flex flex-wrap">
          {item.tags.slice(0, 2).map((tag, index) => (
            <span 
              key={index}
              className="text-xs bg-gray-200 text-gray-700 rounded-full px-2 py-0.5 mr-1 mb-1"
            >
              {tag}
            </span>
          ))}
          {item.tags.length > 2 && (
            <span className="text-xs bg-gray-200 text-gray-700 rounded-full px-2 py-0.5 mr-1 mb-1">
              +{item.tags.length - 2}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default MoodboardItem;
